export const LOG_LEVEL_ORDER = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
};
export const EVENT_NAME = 'interlucent:log';
